import 'whatwg-fetch';
import React, { ComponentType } from 'react';
import ReactDOM from 'react-dom';
import { loadAppConfiguration } from 'utils/config/appConfig';
import App from './App';
// import * as serviceWorker from './serviceWorker';

function render(AppComponent: ComponentType) {
  ReactDOM.render(<AppComponent />, document.getElementById('root'));
}

loadAppConfiguration('/config.json').then(() => {
  render(App);
});

if (import.meta.hot) {
  import.meta.hot.accept('./App', (newModule) => {
    if (newModule) {
      render(newModule.default);
    }
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
